import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './app/store';
import App from './App';
import { onUnauthorized } from './services/api';
import { logout } from './features/auth/authSlice';
import './index.css';

onUnauthorized((message) => {
  if (store.getState().auth.token) store.dispatch(logout(message));
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
